import { render, staticRenderFns } from "./MetricTable.vue?vue&type=template&id=f8eca0de"
import script from "./MetricTable.vue?vue&type=script&lang=js"
export * from "./MetricTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports